import Caelushome1 from '../../Media/homeimages/Caelus 2.webp'
import Caelushome2 from '../../Media/homeimages/Caelus 2.webp'





const Caelushomeimages =[
Caelushome1,Caelushome2
]

export default Caelushomeimages;